// extracted by mini-css-extract-plugin
export default {"container":"ModalFooter_container__Fml4k","__shiftRight":"ModalFooter___shiftRight__9Xaz+"};